import { render, staticRenderFns } from "./FormResearch4.vue?vue&type=template&id=15496d0b&scoped=true&"
import script from "./FormResearch4.vue?vue&type=script&lang=js&"
export * from "./FormResearch4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15496d0b",
  null
  
)

export default component.exports